'use client';

import { useEffect, useState } from 'react';

import { usePathname } from 'next/navigation';

import { userUIStore } from '@/stores/userUIStore';

export const useSidebarPadding = () => {
  const { isSidebarOpen } = userUIStore();
  const pathname = usePathname();
  const isProfilePage = pathname.includes('/dashboard');
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const updateWindowWidth = () => {
      setWindowWidth(window.innerWidth);
    };

    updateWindowWidth();

    const handleResize = (): void => {
      updateWindowWidth();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const updateControlPadding = () => {
      const controlPaddingElement = document.querySelector('.control-padding');

      if (!controlPaddingElement || !(controlPaddingElement instanceof HTMLElement)) {
        return;
      }

      controlPaddingElement.classList.remove('md:ml-72', 'lg:mr-8', 'md:ml-20', 'md:ml-32');
      controlPaddingElement.style.marginLeft = '';
      controlPaddingElement.style.marginRight = '';

      if (windowWidth < 768) {
        controlPaddingElement.style.marginLeft = '0';
        controlPaddingElement.style.marginRight = '0';
        return;
      }

      if (windowWidth < 908) {
        controlPaddingElement.style.marginLeft = '2rem';
        controlPaddingElement.style.marginRight = '2rem';
        return;
      }

      if (isSidebarOpen) {
        if (isProfilePage) {
          controlPaddingElement.style.marginLeft = '8rem';
          controlPaddingElement.style.marginRight = '1rem';
        } else {
          controlPaddingElement.style.marginLeft = '15rem';
          controlPaddingElement.style.marginRight = '2rem';
        }
      } else if (isProfilePage) {
        controlPaddingElement.style.marginLeft = '0rem';
        controlPaddingElement.style.marginRight = '1rem';
      } else {
        controlPaddingElement.style.marginLeft = '6rem';
        controlPaddingElement.style.marginRight = '2rem';
      }
    };

    updateControlPadding();
  }, [isSidebarOpen, isProfilePage, windowWidth]);
};
